export default __webpack_public_path__ + "static/media/mar-del-plata.77b66ea5.jpg";